/**
 * Playable Sonic Pi FX synthdefs (supersonic-scsynth-synthdefs@0.67.2).
 * Auto-generated — run build-fx-manifest.js to refresh.
 */

const FX_MENU_ITEMS = [
    {
        "text": "autotuner",
        "value": "autotuner"
    },
    {
        "text": "band eq",
        "value": "band_eq"
    },
    {
        "text": "bitcrusher",
        "value": "bitcrusher"
    },
    {
        "text": "bpf",
        "value": "bpf"
    },
    {
        "text": "compressor",
        "value": "compressor"
    },
    {
        "text": "distortion",
        "value": "distortion"
    },
    {
        "text": "echo",
        "value": "echo"
    },
    {
        "text": "eq",
        "value": "eq"
    },
    {
        "text": "flanger",
        "value": "flanger"
    },
    {
        "text": "gverb",
        "value": "gverb"
    },
    {
        "text": "hpf",
        "value": "hpf"
    },
    {
        "text": "ixi techno",
        "value": "ixi_techno"
    },
    {
        "text": "krush",
        "value": "krush"
    },
    {
        "text": "level",
        "value": "level"
    },
    {
        "text": "lpf",
        "value": "lpf"
    },
    {
        "text": "mono",
        "value": "mono"
    },
    {
        "text": "nbpf",
        "value": "nbpf"
    },
    {
        "text": "nhpf",
        "value": "nhpf"
    },
    {
        "text": "nlpf",
        "value": "nlpf"
    },
    {
        "text": "normaliser",
        "value": "normaliser"
    },
    {
        "text": "nrbpf",
        "value": "nrbpf"
    },
    {
        "text": "nrhpf",
        "value": "nrhpf"
    },
    {
        "text": "nrlpf",
        "value": "nrlpf"
    },
    {
        "text": "octaver",
        "value": "octaver"
    },
    {
        "text": "pan",
        "value": "pan"
    },
    {
        "text": "panslicer",
        "value": "panslicer"
    },
    {
        "text": "ping pong",
        "value": "ping_pong"
    },
    {
        "text": "pitch shift",
        "value": "pitch_shift"
    },
    {
        "text": "rbpf",
        "value": "rbpf"
    },
    {
        "text": "reverb",
        "value": "reverb"
    },
    {
        "text": "rhpf",
        "value": "rhpf"
    },
    {
        "text": "ring mod",
        "value": "ring_mod"
    },
    {
        "text": "rlpf",
        "value": "rlpf"
    },
    {
        "text": "slicer",
        "value": "slicer"
    },
    {
        "text": "tanh",
        "value": "tanh"
    },
    {
        "text": "tremolo",
        "value": "tremolo"
    },
    {
        "text": "vowel",
        "value": "vowel"
    },
    {
        "text": "whammy",
        "value": "whammy"
    },
    {
        "text": "wobble",
        "value": "wobble"
    }
];

const FX_SYNTHDEFS = {
    "autotuner": "sonic-pi-fx_autotuner",
    "band_eq": "sonic-pi-fx_band_eq",
    "bitcrusher": "sonic-pi-fx_bitcrusher",
    "bpf": "sonic-pi-fx_bpf",
    "compressor": "sonic-pi-fx_compressor",
    "distortion": "sonic-pi-fx_distortion",
    "echo": "sonic-pi-fx_echo",
    "eq": "sonic-pi-fx_eq",
    "flanger": "sonic-pi-fx_flanger",
    "gverb": "sonic-pi-fx_gverb",
    "hpf": "sonic-pi-fx_hpf",
    "ixi_techno": "sonic-pi-fx_ixi_techno",
    "krush": "sonic-pi-fx_krush",
    "level": "sonic-pi-fx_level",
    "lpf": "sonic-pi-fx_lpf",
    "mono": "sonic-pi-fx_mono",
    "nbpf": "sonic-pi-fx_nbpf",
    "nhpf": "sonic-pi-fx_nhpf",
    "nlpf": "sonic-pi-fx_nlpf",
    "normaliser": "sonic-pi-fx_normaliser",
    "nrbpf": "sonic-pi-fx_nrbpf",
    "nrhpf": "sonic-pi-fx_nrhpf",
    "nrlpf": "sonic-pi-fx_nrlpf",
    "octaver": "sonic-pi-fx_octaver",
    "pan": "sonic-pi-fx_pan",
    "panslicer": "sonic-pi-fx_panslicer",
    "ping_pong": "sonic-pi-fx_ping_pong",
    "pitch_shift": "sonic-pi-fx_pitch_shift",
    "rbpf": "sonic-pi-fx_rbpf",
    "reverb": "sonic-pi-fx_reverb",
    "rhpf": "sonic-pi-fx_rhpf",
    "ring_mod": "sonic-pi-fx_ring_mod",
    "rlpf": "sonic-pi-fx_rlpf",
    "slicer": "sonic-pi-fx_slicer",
    "tanh": "sonic-pi-fx_tanh",
    "tremolo": "sonic-pi-fx_tremolo",
    "vowel": "sonic-pi-fx_vowel",
    "whammy": "sonic-pi-fx_whammy",
    "wobble": "sonic-pi-fx_wobble"
};

module.exports = {
    FX_MENU_ITEMS,
    FX_SYNTHDEFS
};
